import { AddIcon } from "@/constant/imagePath";

function BaseAdd({ addData }) {
  return (
    <button
      onClick={addData?.onClick}
      className="h-8 min-w-[96px] px-[16px] bg-golden-gradient flex items-center justify-center gap-x-2 font-extralight text-sm text-white hover:underline underline-offset-1 rounded-7 shadow-primary-inset"
    >
      <img src={AddIcon} className="h-4" alt="Add" />
      <span>Add</span>
    </button>
  );
}

export default BaseAdd;
